import { legendListContainer } from './legendListCssDefs';
import React from 'react';

export interface LegendListProps {
  /**
   * list items, expect LegendListItem
   */
  children: React.ReactNode;
  /**
   * list layout, default is vertical
   */
  orientation?: 'horizontal' | 'vertical';
  /**
   * Spacing between list items
   */
  gap?: number;
}

/**
 * A component to render a list that contains mapping of icons => definitions
 */
export const LegendList: React.FC<React.PropsWithChildren<LegendListProps>> = ({
  children,
  orientation = 'vertical',
  gap = 1.5,
}) => {
  return <dl css={legendListContainer(orientation, gap)}>{children}</dl>;
};
